import _ from 'lodash';

import utils from '@utils';

/**
 * me取得
 */
export const getMe = async () => {
  const res = await utils.axios.slsGo().get(`/me`);

  return res.data;
};

/**
 * ユーザー単体取得
 * @param id ユーザーID
 */
export const getOne = async (id: string) => {
  const res = await utils.axios.slsGo().get(`/users/${id}`);

  return res.data;
};

/**
 * ユーザー登録
 * @param b ユーザー登録のリクエストボディ
 */
export const create = async (b: UserCreateBody) => {
  const res = await utils.axios.slsGo().post(`/users`, b);

  return res.data;
};

/**
 * ユーザーアクティベート
 * @param b ユーザーアクティベートのリクエストボディ
 */
export const activate = async (b: UserActivateBody) => {
  const res = await utils.axios.slsGo().put(`/users_activate`, b);

  return res.data;
};

/**
 * ユーザー更新
 * @param b ユーザー更新のリクエストボディ
 * @param id 対象のユーザーID
 */
export const update = async (b: UserUpdateBody, id: string) => {
  const res = await utils.axios.slsGo().put(`/users/${id}`, b);

  return res.data;
};

/**
 * ユーザー権限ダウングレード (管理者から一般ユーザーに変更)
 * @param b ユーザー更新のリクエストボディ
 * @param id 対象のユーザーID
 */
export const downgrade = async (id: number) => {
  const res = await utils.axios.slsGo().put(`/users_downgrade/${id}`);

  return res.data;
};

/**
 * ユーザー削除
 * @param id 対象のユーザID
 */
export const destroy = async (id: string) => {
  const res = await utils.axios.slsGo().delete(`/users/${id}`);

  return res.data;
};

/**
 * ユーザーページネーション取得
 * @param qp ユーザーページネーションのクエリパラメータ
 */
export const paging = async (qp: PaginationActionInput) => {
  // nullを渡すと期待通りの値が返ってこないため、キーそのものを渡さないようにする
  if (_.isNull(qp.prefecture)) {
    qp.prefecture = undefined;
  }

  const res = await utils.axios.slsGo().get('/users_paging', {params: qp});
  return res;
};

/**
 * ユーザー一覧取得
 */
export const getAll = async (qp: UserGetAllQueryParams) => {
  const res = await utils.axios.slsGo().get('/users', {params: qp});

  return res;
};

/**
 * Cognitoユーザー登録 (管理者作成時に利用)
 * @param b UserPostCognitoUser
 */
export const createCognitoUser = async (b: UserPostCognitoUser) => {
  const res = await utils.axios.slsGo().post('/users_cognito', b);

  return res.data;
};

/**
 * チームのユーザー数を取得
 */
export const getUsersCount = async (qp: UsersGetUsersCountQueryParams) => {
  const res = await utils.axios.slsGo().get(`/users_count`, {params: qp});

  return res.data;
};

/**
 * 登録完了時にメールを送信する
 */
export const sendSuccessMail = async (b: UserPostRegistrationBody) => {
  await utils.axios.slsGo().post('users_registration_notice', b);
};

/**
 * 迷惑メールとして報告する
 */
export const sendComplaint = async (b: UserPostComplaintBody) => {
  await utils.axios.slsGo().post('/user_notifications_complaint', b);
};

/**
 * チーム内でメールアドレス・電話番号が重複していないかを確認する
 */
export const isUsersUnique = async (b: UserGetUniqueBody) => {
  await utils.axios.slsGo().post(`/users_unique_check`, b);
};

/**
 * 特権管理者・管理者のメールアドレスがで重複していないか確認する (SNSログイン時に使用されるメールアドレスも重複確認対象)
 */
export const isLoginUsersUnique = async (b: UserUniqueCheckBody) => {
  await utils.axios.slsGo().post(`/users_login_user_unique_check`, b);
};

/**
 * CognitoUserの削除を行う
 */
export const deleteCognitoUser = async (cognitoUserName: string) => {
  await utils.axios
    .slsGo()
    .delete(`/users_cognito?cognitoUserName=${cognitoUserName}`);
};
